import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const progressBarDefaultVariants = {
  "size": "md",
  "color": "green",
  "rounded": true,
  "labelPosition": "none",
  "textColor": "black",
  "loading": false,
  "isZero": false
}
const progressBarCompoundVariants = []

const progressBarSlotNames = [
  [
    "wrapper",
    "progressBar__wrapper"
  ],
  [
    "root",
    "progressBar__root"
  ],
  [
    "indicator",
    "progressBar__indicator"
  ],
  [
    "label",
    "progressBar__label"
  ],
  [
    "shimmer",
    "progressBar__shimmer"
  ]
]
const progressBarSlotFns = /* @__PURE__ */ progressBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, progressBarDefaultVariants, getSlotCompoundVariant(progressBarCompoundVariants, slotName))])

const progressBarFn = memo((props = {}) => {
  return Object.fromEntries(progressBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const progressBarVariantKeys = [
  "rounded",
  "size",
  "labelPosition",
  "textColor",
  "color",
  "loading",
  "isZero"
]
const getVariantProps = (variants) => ({ ...progressBarDefaultVariants, ...compact(variants) })

export const progressBar = /* @__PURE__ */ Object.assign(progressBarFn, {
  __recipe__: false,
  __name__: 'progressBar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: progressBarVariantKeys,
  variantMap: {
  "rounded": [
    "true",
    "false"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "labelPosition": [
    "none",
    "left",
    "right",
    "top"
  ],
  "textColor": [
    "black",
    "green"
  ],
  "color": [
    "brand",
    "green",
    "orange"
  ],
  "loading": [
    "true",
    "false"
  ],
  "isZero": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, progressBarVariantKeys)
  },
  getVariantProps
})